import React from 'react';
import Image from 'next/image';
import { Card } from '@/components/ui/card';
import fixNewsContent from '@/lib/SVG_Render';
//  types for the component props
interface AboutSectionProps {
  title: string;
  description: string;
  image: string;
}

export const AboutSection: React.FC<AboutSectionProps> = ({ title, description, image}) => {
  return (
      <Card className='bg-primary p-4 md:p-6 '>
        <h2 className="text-base md:text-xl font-bold text-background md:mb-2">
            {title}
        </h2>
            {/* title and description text content*/}
           <div className="clearfix">
              {/* image first */}
              <img
                src={image || "/default.jpg"}
                alt="about img"
                loading="lazy"
                className="w-full h-auto mb-4 md:float-right md:w-1/2 xl:w-1/3 md:ml-4 object-cover rounded-xl"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 500px"
              />

              {/* text content */}
              <div
                className="prose text-background text-sm leading-relaxed mb-3 lg:mb-0"
                dangerouslySetInnerHTML={{ __html: fixNewsContent(description) }}
              />
            </div>

       
      </Card>
  );
};
